"use client";

import { ActivityLogCard } from "./activity-log-card";
import { Button } from "@/components/ui/button";
import { ChevronLeftIcon, ChevronRightIcon } from "lucide-react";
import type { LogEventViewModel } from "@/types/activity-log";

function ActivityLogList({
  items,
  totalCount,
  page,
  pageSize,
  paginationSizes,
  onPageChange,
  onOpenDetail,
}: {
  items: LogEventViewModel[];
  totalCount: number;
  page: number;
  pageSize: number;
  paginationSizes: readonly number[];
  onPageChange: (params: { page: number; size: number }) => void;
  onOpenDetail: (id: number) => void;
}) {
  const totalPages = Math.max(1, Math.ceil(totalCount / pageSize));
  const start = (page - 1) * pageSize + 1;
  const end = Math.min(page * pageSize, totalCount);

  return (
    <div className="space-y-4">
      <div className="space-y-3">
        {items.map((item) => (
          <ActivityLogCard
            key={item.id}
            item={item}
            onOpenDetail={onOpenDetail}
          />
        ))}
      </div>
      {(totalCount > 0 || page > 1) && (
        <div className="flex flex-wrap items-center justify-between gap-4 border-t pt-4">
          <div className="text-muted-foreground text-sm">
            {totalCount === 0 ? (
              "Aucun résultat"
            ) : (
              <>
                {start}–{end} sur {totalCount}
              </>
            )}
          </div>
          <div className="flex items-center gap-2">
            <span className="text-muted-foreground text-sm">Par page</span>
            <select
              className="border-input bg-background h-9 rounded-md border px-2 text-sm"
              value={pageSize}
              onChange={(e) =>
                onPageChange({ page: 1, size: Number(e.target.value) })
              }
            >
              {paginationSizes.map((s) => (
                <option key={s} value={s}>
                  {s}
                </option>
              ))}
            </select>
            <div className="flex gap-1">
              <Button
                variant="outline"
                size="icon-sm"
                disabled={page <= 1}
                onClick={() => onPageChange({ page: page - 1, size: pageSize })}
                aria-label="Page précédente"
              >
                <ChevronLeftIcon className="size-4" />
              </Button>
              <Button
                variant="outline"
                size="icon-sm"
                disabled={page >= totalPages}
                onClick={() => onPageChange({ page: page + 1, size: pageSize })}
                aria-label="Page suivante"
              >
                <ChevronRightIcon className="size-4" />
              </Button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export { ActivityLogList };
